import { ca } from '@cian/analytics';

export function trackSellersCarouselOfferClick({
  offerId,
  position,
  agentId,
}: {
  offerId: number;
  position: number;
  agentId: number;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'media_agent_banner_carousel_to_card',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: position + 1,
      },
    ],
    page: {
      extra: {
        agentId,
      },
    },
  });
}
